import React from 'react';

const HactivateContainer = (props) => {

  const styles = {
    backgroundColor: props.bgColor,
    position: 'relative',
    maxWidth: '320px',
    width: '80vw',
    margin: '0 auto',
  }

  return (
    <div className="hactivateContainer" style={styles}>
      { props.children }
    </div>
  );
}

export default HactivateContainer;



// WEBPACK FOOTER //
// ./src/components/HactivateContainer/index.js